import { useEffect, useState } from "react";

export interface UseCountdownReturnValues {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  countDown: number;
  resetCountDown: () => void;
}

const useCountdown = (
  targetDate: Date | string | null | undefined
): UseCountdownReturnValues => {
  const [countDown, setCountDown] = useState(0);

  useEffect(() => {
    // Only set up the countdown if we have a valid target date
    if (!targetDate) {
      setCountDown(0);
      return;
    }

    const countDownDate = new Date(targetDate).getTime();

    // Initial calculation
    const calculateDiff = () => {
      const now = new Date().getTime();
      return Math.max(0, countDownDate - now);
    };

    // Set initial countdown state
    setCountDown(calculateDiff());

    // Set up interval for countdown
    const interval = setInterval(() => {
      const diff = calculateDiff();
      setCountDown(diff);

      // Clear interval when countdown reaches 0
      if (diff <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const resetCountDown = () => {
    setCountDown(0);
  };

  return { ...getReturnValues(countDown), resetCountDown };
};

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds, countDown };
};

export { useCountdown, getReturnValues };
